import { Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const HeadSeemore = ({ to, head, seemore }) => {
  return (
    <Flex justify='space-between' color='#3C1A5B' align='center' pb='1'>
      <Text fontWeight='600' fontSize='16px'>
        {head}
      </Text>
      {seemore && (
        <Link to={to}>
          <Text _hover={{ decoration: 'underline' }} fontSize='12px'>
            See more
          </Text>
        </Link>
      )}
    </Flex>
  );
};

export default HeadSeemore;
